const STATS = [
  { icon: "ri-building-2-line", value: "150+", label: "Projetos Realizados" },
  { icon: "ri-hammer-line", value: "80+", label: "Obras Executadas" },
  { icon: "ri-user-star-line", value: "120+", label: "Clientes Atendidos" },
  { icon: "ri-calendar-check-line", value: "10+", label: "Anos de Mercado" },
];

export default function NumbersSection() {
  return (
    <section className="py-20" style={{ backgroundColor: "#1E3A8A" }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-0 md:divide-x md:divide-white/20">
          {STATS.map((stat, index) => (
            <div
              key={stat.label}
              className="flex flex-col items-center justify-center text-center py-10 px-6"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className={`${stat.icon} text-4xl`} style={{ color: "#C9A24A" }} />
              </div>
              <p
                className="text-white font-bold text-6xl mb-2"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {stat.value}
              </p>
              <p className="text-white/80 text-base">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
